import React, { useEffect, useState } from "react";
import { FaRegCalendarAlt } from "react-icons/fa";
import { SiSpeedtest } from "react-icons/si";
import RemainingTS from "../card-two-side/remaining-ts";
import RemainingWS from "../card-two-side/remaining-ws";
import ServiceIcon from "../card-two-side/service-icon";
import BeforAfterWS from "../card-two-side/befor-after-ws";
import BeforAfterTS from "../card-two-side/befor-after-ts";
import { RiDeleteBinLine } from "react-icons/ri";
import BottomSheet from "../../bottom-sheet/bottom-sheet";
import { Link } from "react-router-dom";
import DeleteService from "./delete-service";
import { useDispatch, useSelector } from "react-redux";
import { resetDeleteState, selectDeleteOperateSuccessState } from "../../../redux/operate/operate-delete-slice";
import { toast } from "react-toastify";
import { parseLocalizedNumber } from "../../../services/functions";


const CardServicesView = ({ service, min, max, now }) => {
  const [progress, setProgress] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  function HandlerCloseButtomSheet() {
    setIsOpen(false);
  }
  useEffect(() => {
    // محاسبه درصد از min و max و now
    const percentage = ((now - min) / (max - min)) * 100;
    setProgress(percentage);
  }, [now, min, max]);

  let printRemain =parseLocalizedNumber(service.remain);

return(
<div className="card mb-2 shadow-sm" style={{ fontSize: "0.9rem" }}>
  <div className="card-header bg-light py-2 px-3">
    <div className="d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center">
        <ServiceIcon categoryId={service.ok_id} size={20} className="me-2"/>
        <div>
          <span className="fw-bold d-block small">{service.opTitle}</span>
          <small className="text-muted">{service.car_title}</small>
        </div>
      </div>
      <div className="text-primary">
        {service.ok_serviceType === "km" 
          ? <SiSpeedtest size={18}/> 
          : <FaRegCalendarAlt size={18}/>}
      </div>
    </div>
  </div>

  <div className="card-body p-2">
    <div className="mb-2">
      {service.ok_serviceType === "km" 
        ? <RemainingWS remain={service.remain}/> 
        : <RemainingTS remain={service.remain}/>}
    </div>

    <div className="progress mb-2" style={{ height: "3px" }}>
      <div
        className={`progress-bar ${printRemain < 0 ? "bg-danger" : "bg-success"}`}
        role="progressbar"
        style={{ width: `${progress}%`, transition: "width 3s ease-in-out" }}
      ></div>
    </div>

    <div className="mb-2">
      {service.ok_serviceType === "km" 
        ? <BeforAfterWS beforService={service.lastKm} afterService={service.programKm}/> 
        : <BeforAfterTS beforService={service.lastDateP} afterService={service.programDateP}/>}
    </div>

    <div className="d-flex justify-content-between text-muted small">
      <span>آخرین بار:</span>
      <span>
        {service.ok_serviceType === "km" ? service.lastDateP : service.lastKm}
      </span>
    </div>

    <div className="d-flex justify-content-between mt-3">
      <Link to={'/oper-reg'} state={service} className="btn btn-success btn-sm flex-grow-1 mx-1">ثبت</Link>
      <Link to={'/operate-edit'} state={service} className="btn btn-outline-primary btn-sm flex-grow-1 mx-1">ویرایش</Link>
      <button onClick={() => setIsOpen(true)} type="button" className="btn btn-outline-danger btn-sm flex-grow-1 mx-1">
        <RiDeleteBinLine size={16}/>
      </button>
    </div>
  </div>

  {/* BottomSheet */}
  <BottomSheet
    isOpen={isOpen}
    children={
      <DeleteService service={service} closeButtomSheetHandler={HandlerCloseButtomSheet} />
    }
    onClose={() => setIsOpen(false)}
    snapPoint="250"
  />
</div>
);

};

export default CardServicesView;
